import React from "react";
import { Calendar, ArrowRight } from "lucide-react";
import { motion } from "framer-motion";

const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
  });
};

const formatTime = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
};

const LiveClassStrip = ({ events = [], onViewAll }) => {
  if (events.length === 0) {
    return (
      <div className="border-2 border-dashed border-gray-300 dark:border-gray-700 rounded-sm p-8 text-center">
        <Calendar className="h-10 w-10 text-gray-300 dark:text-gray-600 mx-auto mb-3" />
        <p className="text-sm font-medium text-gray-500 dark:text-gray-400">
          No Upcoming Classes
        </p>
        <p className="text-xs text-gray-400 dark:text-gray-500 mt-1">
          New classes scheduled by your teachers will appear here.
        </p>
      </div>
    );
  }

  return (
    <div className="flex overflow-x-auto snap-x snap-mandatory scrollbar-hide gap-4 pb-2">
      {events.map((event, index) => (
        <motion.div
          key={event._id}
          initial={{ opacity: 0, x: 30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.35, delay: 0.9 + index * 0.1 }}
          className="w-72 sm:w-80 flex-shrink-0 snap-start"
        >
          <div
            className="group flex flex-col bg-white dark:bg-gray-800 rounded-sm border border-gray-200 dark:border-gray-700 shadow-sm dark:shadow-none hover:border-accent1/60 dark:hover:border-accent1/60 hover:shadow-md transition-all duration-200 overflow-hidden cursor-pointer h-full"
            onClick={() => window.open(event.link, "_blank")}
          >
            {/* Text-forward card */}
            <div className="p-4 sm:p-5 flex-1">
              {/* Date badge */}
              <div className="inline-flex items-center gap-1.5 px-2.5 py-1 bg-accent1/15 rounded-sm mb-3">
                <Calendar className="h-3 w-3 text-accent1" />
                <span className="text-xs font-medium text-accent1">
                  {formatDate(event.start || event.instanceStart)} · {formatTime(event.start || event.instanceStart)}
                </span>
              </div>

              <h3 className="text-base font-bold text-gray-900 dark:text-white group-hover:text-accent1 transition-colors line-clamp-2 mb-1.5">
                {event.subject}
              </h3>
              <p className="text-xs text-gray-500 dark:text-gray-400 line-clamp-2">
                {event.description}
              </p>
            </div>

            {/* CTA */}
            <div className="border-t border-gray-200 dark:border-gray-700 px-4 sm:px-5 py-2.5 flex items-center justify-between">
              <span className="text-sm font-semibold uppercase tracking-wide text-accent1">
                Join Class
              </span>
              <ArrowRight className="h-4 w-4 text-accent1" />
            </div>
          </div>
        </motion.div>
      ))}
    </div>
  );
};

export default LiveClassStrip;
